import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import styled, { withTheme } from 'styled-components'
import { CardContainer } from '../Reusable/CardContainer'
import { Flex, FlexColumn } from '../../Reusable/Container'
import environment from '../../../environment'

import AppIcon from '../../../Images/connections-active.svg'
import { apiPOSTReq, trackEvent } from '../../../Utils/api'
import CardHeader from '../Reusable/CardHeader'
import LucideIcon, { TextButton } from '../../Reusable/Button'
import { Image } from '../../Reusable/Image'
import ArrowRight from "../../../Images/arrow-right.png"
import { Tag, Text } from '../../Reusable/Text'
import { getDateInLocalTZ, toCurrency } from '../../../Utils/util'
import TableView from '../../Reusable/TableView'
import hexToRgba from 'hex-to-rgba'
import { InitialCircle } from '../../Reusable/InitialCircle'
import { ErrorAlert } from '../../Reusable/Alert'
import { ScrollableTableView } from '../Reusable/ScrollableTableView'

import { CircleAlert, CircleMinus, Landmark, PanelsTopLeft, Plus, PlusCircle, Receipt, TriangleAlert, Unlink, Waypoints } from 'lucide-react'
import OverlayContainer from '../Reusable/OverlayContainer'
import { extAccounts } from '../Utils/EmptyStateData'
import ExtBBTransactions from '../../Reusable/ExtBBTransactions'
import BankConnect from '../../Settings/External Bank Connect/Index';
import { Modal } from 'antd'
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons'

const StyledHeader = styled.div`
    background: ${props => hexToRgba(props.theme.colors.primary2, 0.04)};
    border: ${props => props.borderView && `1px solid ${props.theme.colors.border}`};
    border-radius: 2px;
    border-bottom: none;
    overflow: hidden;
`;

const ScrollWrapper = styled.div`
    height: 275px;
    position: relative;
    overflow: hidden;
`;

const ScrollContent = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: auto;
`;

class ExtAccounts extends Component {
    state = {
        loading: true,
        emptyStateCard: false,
        emptyStateData: extAccounts,
        extBBInstitutions: [],
        extBBAccounts: []
    }

    componentDidMount() {
        this.getAccounts();
    }

    getAccounts = () => {
        var body = {}

        this.setState({ loading: true });
        apiPOSTReq(`${environment.integrationBaseUrl}/extbb/getAccounts`, {}, body, (err, resp) => {
            try {
                const data = resp || {};
                if (data.result) {
                    var emptyStateCard = (data.extBBAccounts || []).length == 0;
                    if(emptyStateCard) {
                        this.setState({
                            emptyStateCard: true,
                            extBBAccounts: this.state.emptyStateData.extBBAccounts || [],
                            extBBInstitutions: this.state.emptyStateData.extBBInstitutions || []
                        });
                    } else {
                        this.setState({
                            emptyStateCard: false,
                            extBBAccounts: data.extBBAccounts || [],
                            extBBInstitutions: data.extBBInstitutions || []
                        });
                    }

                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR /payables/bills/extBBAccounts", error, err, resp)
            } finally {
                this.setState({ loading: false })
            }
        })
    }

    getInstitution = (itemId) => {
        var { extBBInstitutions } = this.state

        var bbInst = extBBInstitutions.find(inst => inst.itemId == itemId)
        return (bbInst || {})
    }

    columns = (credit) => {
        var cItems = [
            {
                title: 'Cash',
                dataIndex: 'title',
                key: 'title',
                render: (title, item) => {
                    var inst = this.getInstitution(item.itemId);
                    
                    return (
                        <Flex start centerHorizontally gap='8px'>
                            <InitialCircle name={inst.bankName} size={30} useFirstWordOnly={true} logoUrl={inst.logoUrl} />
                            
                            <FlexColumn start gap='2px'>
                                <Flex start centerHorizontally gap='4px'>
                                    <Text color={this.props.theme.colors.primary2}>{title}</Text>
                                    {
                                        inst.status != 'Connected' && 
                                        <LucideIcon
                                            title='Disconnected: Click to update'
                                            padding='4px'
                                            onClick={() => {
                                                trackEvent({ name: "dashboard_cta", property: `disconnected connection` });
                                                this.props.history.push('/settings/profile')
                                            }}
                                            icon={TriangleAlert} color={this.props.theme.colors.primary7} size={12} 
                                        />
                                    }
                                </Flex>
                                <Text size={'12px'} height={'14px'} weight={500} color={hexToRgba(this.props.theme.colors.primary2, 0.5)}>{inst.bankName}</Text>
                            </FlexColumn>
                        </Flex>
                    )
                }
            },
            
    
        ];

        if(credit) {
            cItems.push({
                title: '',
                dataIndex: 'currentBalance',
                key: 'amount',
                render: (currentBalance, record) => <span style={{ fontWeight: 600 }}>{`$${toCurrency(currentBalance)}`}</span>,
                align: 'right'
            })
        } else {
            cItems.push({
                title: '',
                dataIndex: 'availableBalance',
                key: 'amount',
                render: (availableBalance, record) => <span style={{ fontWeight: 600 }}>{`$${toCurrency(availableBalance || record.currentBalance)}`}</span>,
                align: 'right'
            })
        }
        return cItems;
    }

    getHeader = (name, value) => {
        const { theme } = this.props;
        return (
            <StyledHeader>
                <Flex centerHorizontally between gap='16px' style={{ padding: '2px 20px' }}>
                    <Text margin='0' weight={500} size='14px' color={theme.colors.primary2}>
                        {name}
                    </Text>
                    {/* <Text margin='0' weight={500} size='15px' color={theme.colors.primary2}>
                        {value}
                    </Text> */}
                    {value}
                </Flex>
            </StyledHeader>
        )
    }

    getBankConnectCta = (cta, iconOnly) => {
        return !this.state.loading && <BankConnect plusIcon onSuccess={() => this.setState({ loading: true })} onComplete={() => this.getAccounts()} store={this.props.store} connectOnly connectCTA={iconOnly ? <LucideIcon title="Connect More" size={16} color={this.props.theme.colors.primary} padding='0px' margin='0' icon={PlusCircle} /> : <TextButton padding='0px' text={cta || "ADD NEW"} icon={<PlusOutlined />} />} />
    }
    
    render() {
        var { extBBAccounts, loading, emptyStateCard, emptyStateData, showAcctTxns, selectedAccount, selectInst } = this.state;
        const { theme, small, store } = this.props;

        if(emptyStateCard) {
            var { extBBAccounts } = emptyStateData;
        }

        var cashAccts = extBBAccounts.filter(acct => (acct.accountType == "depository"));
        var liabilityAccts = extBBAccounts.filter(acct => (acct.accountType == "credit"));
        var otherAccts = extBBAccounts.filter(acct => !(["depository", "credit"].includes(acct.accountType)));

        var cashSum = 0;
        cashAccts.forEach(acct => cashSum += acct.availableBalance);

        var lSum = 0;
        liabilityAccts.forEach(acct => lSum += acct.currentBalance);

        var oSum = 0;
        otherAccts.forEach(acct => oSum += acct.availableBalance);

        if(!emptyStateCard)
            return (
                <>
                    <CardContainer small={small}>
                        <FlexColumn>
                            <CardHeader 
                                imgSrc={AppIcon}
                                titleText='Connections' 
                                desc='Linked accounts'
                                path='settings/profile'
                                secondaryContent={
                                    <FlexColumn centerVertically>
                                        {<TextButton 
                                            onClick={() => {
                                                trackEvent({ name: "dashboard_cta", property: `manage connections` });
                                                this.props.history.push('settings/profile')
                                            }} 
                                            rightIcon={<Image src={ArrowRight} />} text="MANAGE" />}
                                    </FlexColumn>
                                }
                            />
                            <ScrollWrapper>
                                <ScrollContent>
                                    <FlexColumn fullWidth gap='0px'>
                                        {this.getHeader("Bank Accounts", this.getBankConnectCta(null, cashAccts.length > 0))}
                                        <ScrollableTableView
                                            id="extbb1"
                                            columns={this.columns()}
                                            dataSource={cashAccts}
                                            rowKey='id'
                                            loading={loading}
                                            borderView
                                            disableAltRowBg
                                            hideHeader
                                            pagination={false}
                                            maxHeight={1000}
                                            onRow={(record, rowIndex) => {
                                                return {
                                                    onClick: event => {
                                                        this.setState({ selectedAccount: record, selectInst: this.getInstitution(record.itemId), showAcctTxns: true })
                                                    }, // click row
                                                }
                                            }}
                                        />
                                    </FlexColumn>

                                    <FlexColumn fullWidth gap='0px'>
                                        {this.getHeader("Credit Cards", this.getBankConnectCta(null, liabilityAccts.length > 0))}
                                        {
                                            liabilityAccts.length > 0 &&
                                            <ScrollableTableView
                                                id="extbb2"
                                                columns={this.columns(true)}
                                                dataSource={liabilityAccts}
                                                rowKey='id'
                                                loading={loading}
                                                borderView
                                                disableAltRowBg
                                                hideHeader
                                                pagination={false}
                                                maxHeight={1000}
                                                onRow={(record, rowIndex) => {
                                                    return {
                                                        onClick: event => {
                                                            this.setState({ selectedAccount: record, selectInst: this.getInstitution(record.itemId), showAcctTxns: true })
                                                        }, // click row
                                                    }
                                                }}
                                            />
                                        }
                                        
                                    </FlexColumn>
                                    {
                                        otherAccts.length > 0 &&
                                        <FlexColumn fullWidth gap='0px'>
                                            {this.getHeader("Other")}
                                            <ScrollableTableView
                                                id="extbb3"
                                                columns={this.columns()}
                                                dataSource={otherAccts}
                                                rowKey='id'
                                                loading={loading}
                                                borderView
                                                disableAltRowBg
                                                hideHeader
                                                pagination={false}
                                                maxHeight={1000}
                                                onRow={(record, rowIndex) => {
                                                    return {
                                                        onClick: event => {
                                                            this.setState({ selectedAccount: record, selectInst: this.getInstitution(record.itemId), showAcctTxns: true })
                                                        }, // click row
                                                    }
                                                }}
                                            />
                                        </FlexColumn>
                                    }
                                </ScrollContent>
                            </ScrollWrapper>
                        </FlexColumn>
                    </CardContainer>
                    <Modal
                        visible={showAcctTxns}
                        style={{ top: 0, padding: 0 }}
                        bodyStyle={{ height: "117.65vh", overflow: "auto", backgroundColor: `#F6F6F6 !important` }}
                        wrapClassName="fullscreen-modal"
                        footer={null}
                        closable={false}
                        destroyOnClose={true}
                    >
                        <ExtBBTransactions
                            account={selectedAccount}
                            institution={selectInst}
                            onClose={() => this.setState({ showAcctTxns: false })}
                        />
                    </Modal>
                </>
            )
        else
            return (
                <CardContainer small={small}>
                    <OverlayContainer 
                        small={small}
                        radial
                        message={
                            <FlexColumn fullWidth center gap='8px'>
                                <LucideIcon icon={PanelsTopLeft} color={theme.colors.primary} size={24} />
                                <Text center heading weight={600}>Connected Accounts</Text>
                                <Text center>Seamlessly link your external accounts to view all your balances here.</Text>
                                {
                                    loading ?
                                    <LoadingOutlined style={{ fontSize: 18 }} spin />
                                    :
                                    this.getBankConnectCta('CONNECT ACCOUNT')}
                            </FlexColumn>
                        }
                    >
                        <FlexColumn start grow>
                            <CardHeader 
                                imgSrc={AppIcon}
                                titleText='Connections' 
                                desc='Linked accounts'
                                path='settings/profile'
                                secondaryContent={
                                    <FlexColumn centerVertically>
                                        {<TextButton 
                                            onClick={() => {
                                                trackEvent({ name: "dashboard_cta", property: `manage connections` });
                                                this.props.history.push('settings/profile')
                                            }} 
                                            rightIcon={<Image src={ArrowRight} />} text="MANAGE" />}
                                    </FlexColumn>
                                }
                            />
                            <ScrollWrapper>
                                <ScrollContent>
                                    <FlexColumn fullWidth gap='0px'>
                                        {this.getHeader("Bank Accounts", cashAccts.length == 0 && this.getBankConnectCta())}
                                        <ScrollableTableView
                                            id="extbb1"
                                            columns={this.columns()}
                                            dataSource={cashAccts}
                                            rowKey='id'
                                            borderView
                                            disableAltRowBg
                                            hideHeader
                                            pagination={false}
                                            maxHeight={1000}
                                            onRow={(record, rowIndex) => {
                                                return {
                                                    onClick: event => {
                                                        this.setState({ selectedAccount: record, selectInst: this.getInstitution(record.itemId), showAcctTxns: true })
                                                    }, // click row
                                                }
                                            }}
                                        />
                                    </FlexColumn>

                                    <FlexColumn fullWidth gap='0px'>
                                        {this.getHeader("Credit Cards", liabilityAccts.length == 0 && this.getBankConnectCta())}
                                        {
                                            liabilityAccts.length > 0 &&
                                            <ScrollableTableView
                                                id="extbb2"
                                                columns={this.columns()}
                                                dataSource={liabilityAccts}
                                                rowKey='id'
                                                borderView
                                                disableAltRowBg
                                                hideHeader
                                                pagination={false}
                                                maxHeight={1000}
                                                onRow={(record, rowIndex) => {
                                                    return {
                                                        onClick: event => {
                                                            this.setState({ selectedAccount: record, selectInst: this.getInstitution(record.itemId), showAcctTxns: true })
                                                        }, // click row
                                                    }
                                                }}
                                            />
                                        }
                                        
                                    </FlexColumn>
                                    <FlexColumn fullWidth gap='0px'>
                                        {this.getHeader("Loans", otherAccts.length == 0 && this.getBankConnectCta())}
                                        {
                                            otherAccts.length > 0 &&
                                            <ScrollableTableView
                                                id="extbb3"
                                                columns={this.columns()}
                                                dataSource={otherAccts}
                                                rowKey='id'
                                                borderView
                                                disableAltRowBg
                                                hideHeader
                                                pagination={false}
                                                maxHeight={1000}
                                                onRow={(record, rowIndex) => {
                                                    return {
                                                        onClick: event => {
                                                            this.setState({ selectedAccount: record, selectInst: this.getInstitution(record.itemId), showAcctTxns: true })
                                                        }, // click row
                                                    }
                                                }}
                                            />
                                        }
                                    </FlexColumn>
                                </ScrollContent>
                            </ScrollWrapper>
                        </FlexColumn>
                    </OverlayContainer>
                </CardContainer>
            )
    }
}

function mapStateToProps(state) {
    return {
        store: state.aionAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(ExtAccounts)))